"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _TableRow = _interopRequireDefault(require("./TableRow.style"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _utils = _interopRequireDefault(require("../../utils/utils"));

var _Divider = _interopRequireDefault(require("../../Divider/Divider"));

var _dec, _class, _class2, _temp;

const NESTING_PADDING = 16;
let TableRow = (_dec = (0, _reactJss.default)(_TableRow.default), _dec(_class = (_temp = _class2 = class TableRow extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.handleListIconClick = this.handleListIconClick.bind(this);
  }

  componentDidMount() {
    const {
      index
    } = this.props;

    if (this.hasNestedChildren()) {
      _reactDom.default.findDOMNode(this.itemRef0).style.paddingLeft = `${index * NESTING_PADDING}px`;
    }
  }

  hasNestedChildren() {
    return this.props.nestedChildren.length > 0;
  }

  handleListIconClick(e) {
    e.stopPropagation();
    if (this.context.visibility === 'disabled') return;
    const {
      id,
      value,
      visibility,
      nestedChildren,
      showNestedChildren
    } = this.props;
    if (visibility === 'disabled') return;
    this.props.onChange({
      id,
      value,
      showNestedChildren: !showNestedChildren,
      nestedChildren
    });
  }

  handleClick() {
    if (this.context.visibility === 'disabled') return;
    const {
      id,
      value
    } = this.props;
    const error = false;
    this.props.onClick({
      id,
      value,
      error
    });
  }

  handleDoubleClick() {
    if (this.context.visibility === 'disabled') return;
    const {
      id,
      value
    } = this.props;
    const error = false;
    this.props.onDoubleClick({
      id,
      value,
      error
    });
  }

  render() {
    const {
      className,
      classes,
      visibility,
      children,
      renderNestedChildren,
      nestedChildren,
      showNestedChildren,
      index,
      size,
      active,
      columnSize,
      rowSize,
      id,
      dataTestId
    } = this.props;
    const hasNestedChildren = this.hasNestedChildren();
    const {
      paddingSize
    } = this.context;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.tableRowContainer, 'scTableRowContainer', {
        nested: hasNestedChildren
      }),
      "data-testid": dataTestId
    }, /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(classes.tableRow, className, {
        active
      }, classes[visibility], classes[`paddingSize${_utils.default.toUpperLatter(paddingSize)}`], classes[`rowSize${_utils.default.toUpperLatter(rowSize)}`], 'scTableRow'),
      onClick: this.handleClick,
      onDoubleClick: this.handleDoubleClick
    }, hasNestedChildren || size ? /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.arrowContainer),
      style: {
        left: (index - 1) * NESTING_PADDING
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.arrow, {
        isOpen: showNestedChildren
      }, {
        active
      }, 'scTableRowArrow'),
      type: "dropdown",
      size: "micro",
      onClick: this.handleListIconClick,
      color: "currentColor"
    })) : null, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.tableList, 'scTableRowList'),
      style: {
        paddingLeft: index * NESTING_PADDING
      }
    }, _react.default.Children.map(children, (child, index) => _react.default.cloneElement(child, {
      ref: el => {
        this[`itemRef${index}`] = el;
      },
      width: columnSize[index],
      dataTestId: child.props.dataTestId || (dataTestId ? `${dataTestId}-cell-${index}` : undefined)
    })))), /*#__PURE__*/_react.default.createElement(_Divider.default, {
      className: (0, _clsx.default)(classes[`divider${_utils.default.toUpperLatter(paddingSize)}`], 'scTableRowDivider')
    }), showNestedChildren ? /*#__PURE__*/_react.default.createElement("div", {
      className: classes.nestedChildrenContainer
    }, renderNestedChildren(nestedChildren, index + 1, columnSize)) : null);
  }

}, (0, _defineProperty2.default)(_class2, "contextTypes", {
  visibility: _propTypes.default.oneOf(['visible', 'disabled', 'hidden']).isRequired,
  paddingSize: _propTypes.default.oneOf(['small', 'medium']).isRequired
}), _temp)) || _class);
TableRow.defaultProps = {
  visibility: 'visible',
  value: {},
  nestedChildren: [],
  size: 0,
  index: 1,
  children: null,
  showNestedChildren: false,
  renderNestedChildren: () => {},
  onDoubleClick: () => {},
  onClick: () => {},
  onChange: () => {},
  columnSize: {},
  rowSize: 'medium'
};
var _default = TableRow;
exports.default = _default;